import axios from "axios";

export const signUrl = (url) => {
    const command = {
        url: url
    };
    const path = __API__ + '/api/sign';
    return axios.post(path, command).then(response => {
        return response.data;
    });
};


// WEBPACK FOOTER //
// ./src/admin/services/UrlSignatureModule.js